<template>
  <div>
    <div class="content">
      <div class="container">
        <div class="details" v-html="content"></div>
        <div id="aboutMap"></div>
        <div id="pickerBox">
          <input id="pickerInput" placeholder="请输入搜索内容" />
        </div>
      </div>
    </div>
    <a href="" class="coord" v-html="lnglatinit"></a>
    <a class="up_top" @click.prevent="animateHander1()" href="#">
      <img
        style="width:50px;display:none"
        @mouseenter="changeImageSrc('d')"
        @mouseleave="changeImageSrc('l')"
        :src="upTopSrc"
        alt=""
      />
    </a>
  </div>
</template>

<script>
import $ from "jquery";
import HeaderA from "@/components/public/headerA";
import Code from "@/components/public/code";
import Footer from "@/components/public/footer";
export default {
  data() {
    return {
      lnglatinit: "",
      toHeaderB: {
        title: "关于我们",
        parent: "关于我们",
        parentLink: "/about/about",
        child: "",
        childLink: "",
        longTop: "",
        longBottom: "",
        shortValue: "About us",
        isLong: false,
        titleShow: false,
        searchShow: false,
        haveVoice: false,
        voiceImage: "",
        voiceTitle: "",
        voiceSrc: "",
        logoSrc: {
          backgroundImage: ""
        }
      },
      content: "",
      upTopSrc: require(`@/assets/images/zhiding_l.png`)
    };
  },
  components: {
    HeaderA,
    Code,
    Footer
  },
  methods: {
    // 回到顶部
    animateHander1() {
      $("html, body")
        .stop()
        .animate({ scrollTop: "0" }, 800);
      return false;
    },
    changeImageSrc(key) {
      this.upTopSrc = require(`@/assets/images/zhiding_${key}.png`);
    },
    resourcesClick(currentRole, key) {
      this.$router.push({ path: currentRole, query: { value: key } });
    },
    // 自动判断内容高度，不足则补
    setHeight() {
      setTimeout(function() {
        $(".details").css("height", "auto");
        let contentHeight =
          $(window).height() -
          $(".logo").height() -
          $(".footer").height() -
          20 -
          40;
        if ($(".details").height() < contentHeight) {
          $(".details").height(contentHeight);
        }
      });
    },
    getMap() {
      const infoWindowContent = [
        this.$store.state.serverImages.infoWindowContent
      ];
      let lng = $(".coord_lng").text();
      let lat = $(".coord_lat").text();

      const coord = [lng ? Number(lng) : 0, lat ? Number(lat) : 0];

      // AMap是高德地图的构造函数，这里.Map是创建地图，.Marker是创建坐标点
      let map = new AMap.Map("aboutMap", {
        //'container'是对应页面盒子的id
        resizeEnable: true, //自适应大小
        zoom: 15, //初始视窗
        center: coord //中心点
      });

      let content = infoWindowContent;

      let infoWindow = new AMap.InfoWindow({
        anchor: "bottom-center",
        content: content.join("<br>")
      });

      // 打开信息窗体
      infoWindow.open(map, coord);

      AMap.plugin(["AMap.ToolBar"], function() {
        //异步同时加载多个插件
        var toolbar = new AMap.ToolBar();
        map.addControl(toolbar);
      });

      AMapUI.setDomLibrary($);

      //加载PoiPicker，loadUI的路径参数为模块名中 'ui/' 之后的部分
      AMapUI.loadUI(["misc/PoiPicker"], function(PoiPicker) {
        var poiPicker = new PoiPicker({
          input: "pickerInput" //输入框id
        });
        //监听poi选中信息
        poiPicker.on("poiPicked", function(poiResult) {
          //用户选中的poi点信息
          console.log(poiResult);
          map = new AMap.Map("aboutMap", {
            zoom: 20, //初始视窗
            center: [poiResult.item.location.lng, poiResult.item.location.lat] //中心点
          });

          AMap.plugin(
            ["AMap.ToolBar", "AMap.Driving", "AMap.Geolocation"],
            function() {
              //异步同时加载多个插件
              var toolbar = new AMap.ToolBar();
              map.addControl(toolbar);

              var driving = new AMap.Driving({
                map: map,
                policy: AMap.DrivingPolicy.LEAST_TIME
              });

              var geolocation = new AMap.Geolocation({
                // 是否使用高精度定位，默认：true
                enableHighAccuracy: true,
                // 设置定位超时时间，默认：无穷大
                timeout: 10000,
                // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
                buttonOffset: new AMap.Pixel(10, 20),
                //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                zoomToAccuracy: true,
                //  定位按钮的排放位置,  RB表示右下
                buttonPosition: "RB"
              });

              geolocation.getCurrentPosition(function(status, result) {
                if (status == "complete") {
                  // 根据起终点经纬度规划驾车导航路线
                  driving.search(
                    new AMap.LngLat(result.position.lng, result.position.lat),
                    new AMap.LngLat(
                      poiResult.item.location.lng,
                      poiResult.item.location.lat
                    ),
                    function(status, result) {}
                  );
                }
              });
            }
          );
        });
      });
    }
  },
  mounted() {
    this.lnglatinit =
      '<p class="coord_lng">' +
      this.$store.state.serverImages.coord.split(",")[0] +
      "</p>" +
      '<p class="coord_lat">' +
      this.$store.state.serverImages.coord.split(",")[1] +
      "</p>";
    this.$nextTick(function() {
      $("#headerContainer501").addClass("active");

      $(".header_nav li").removeClass("active");
    });

    this.toHeaderB.child = "介绍信息";
    this.toHeaderB.longTop = "Plant";
    // this.toHeaderB.logoSrc.backgroundImage =
    //   "url(" + require("../../assets/images/banner/关于我们banner.png") + ")";
    this.axios
      .get(
        this.$store.state.Url10 + "wetland/moreservice/queryAboutUsNewlyOne",
        {
          // 通过这种方式解决模糊匹配后台报空指针异常的问题
          params: {
            soId: this.$store.state.Soid
          }
        }
      )
      .then(data => {
        data = data.data.data;
        this.content = data.content;
        this.toHeaderB.titleShow = true;
        this.setHeight();
      })
      .catch(err => {
        console.log(err);
      });

    this.$nextTick(() => {
      this.getMap();
    });
  },
  activated() {

    // this.judgeType();
    $(".up_top img:hover").src = require("@/assets/images/zhiding_d.png");
    var window_height = document.documentElement.clientHeight - 100;
    // 用户手动修改浏览器可见区域高度时修改变量
    window.onresize = function() {
      window_height = document.documentElement.clientHeight;
    };

    window.onscroll = function() {
      // 获取鼠标滚轮滚动距离
      var _scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;

      $(".el-timeline").css(
        "top",
        460 - (_scrollTop > 130 ? 130 : _scrollTop) + "px"
      );
      console.log(_scrollTop)
      var mainH = $(".container").height() - $(".footer").height();
      if (_scrollTop > 500) {
        console.log(444444)
        $(".up_top img").show(200);
      } else {
        $(".up_top img").hide(200);
      }
      $(".up_top").css(
        "bottom",
        (_scrollTop + document.body.clientHeight + 31 > mainH
          ? _scrollTop + document.body.clientHeight - mainH + 81
          : 50) + "px"
      );
    };
  }
};
</script>

<style scoped="scoped">
.banner_nav {
  width: 100%;
  height: 300px;
  background-image: url("http://47.110.245.84:9010/zhsd/zhsdImages/attachFiles/T_TOURIST_RESOURCES/74be147b1a5842a3ad95294ffa2327d1.png");
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  position: relative;
}
.up_top {
  width: 50px;
  position: fixed;
  display: none;
  right: 50px;
  bottom: 300px;
}
.logo {
  background-size: 100% 100% !important;
}
.container {
  text-align: left;
  padding: 20px 7% 20px 7%;
  background-color: white;
  position: relative;
}
#aboutMap {
  width: 100%;
  height: 400px;
}
#pickerBox {
  position: absolute;
  z-index: 9999;
  bottom: 350px;
  right: -50px;
  width: 300px;
}
#pickerInput {
  width: 150px;
  height: 30px;
  font-size: 16px;
  border-radius: 5px;
  border: 1px solid #b4b4b4;
  padding: 0 5px;
}
.container >>> .amap-logo {
  bottom: -30px;
}
.container >>> .amap-copyright {
  bottom: -30px;
}

.coord {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/about/about.vue